import styled, { css } from 'styled-components';
import { FlexCenter } from '../../global/commonStyle';
import { AVATAR_BORDER } from '../../global/constants';

interface Props {
  padding?: string;
  borderRadius?: string;
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';
  borderVariant?: (typeof AVATAR_BORDER)[keyof typeof AVATAR_BORDER];
}

export const StyledImage = styled.img<Props>`
  ${FlexCenter}
  padding:${({ padding }) => padding};
  border-radius: ${({ borderRadius }) => borderRadius};
  object-fit: ${({ objectFit }) => objectFit};
  ${({ borderVariant }) =>
    borderVariant === AVATAR_BORDER.THICK &&
    css`
      border: 5px solid var(--background-secondary);
      border-radius: var(--border-radius-full);
    `}
  ${({ borderVariant }) =>
    borderVariant === AVATAR_BORDER.THIN &&
    css`
      border: 1px solid var(--background-secondary);
      border-radius: var(--border-radius-full);
    `}
  ${({ borderVariant }) =>
    borderVariant === AVATAR_BORDER.NONE &&
    css`
      border: none;
    `}
  ${({ borderVariant }) =>
    borderVariant === AVATAR_BORDER.MEDIUM &&
    css`
      border: 2px solid var(--background-secondary);
    `}
`;
